import { useEffect } from 'react';
import { CircularProgress } from '@mui/material';
import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import { useGetUrl } from '../services/configManager';
import { SecureDataProvider } from '../SecureDataProvider';

const LoginPage = () => {
  const { user } = useAuth0();
  const url = useGetUrl();
  useEffect(() => {
    if (user) {
      window.location.assign(url);
    }
  }, [user?.email, url]);

  return <CircularProgress />;
};

const LoginPageWrapper = () => {
  return (
    <SecureDataProvider>
      <LoginPage />
    </SecureDataProvider>
  );
};

export const Login = withAuthenticationRequired(LoginPageWrapper);
